import { useMutation, useQueryClient, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";
import toast from "react-hot-toast";
import createNotification from "shared/@utils/createNotification";

export function useEscalations() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, status, isLoading, refetch } = useQuery(["incidents"], () =>
    makeAuthedRequest(`/incidents`, {
      method: "GET",
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    status,
    isLoading,
    refetch,
  };
}

export function useSuspendUser() {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const suspendUser = async (incident) => {
    return makeAuthedRequest(`/incidents/suspend-user`, {
      method: "PUT",
      body: JSON.stringify(incident),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        createNotification({
          type: "danger",
          title: "Error",
          message: body.error,
          autoDismiss: true,
        });
        throw new Error(body.error);
      }
    });
  };

  const { mutate } = useMutation(suspendUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("incident");
      createNotification({
        type: "success",
        title: "Saved",
        message: "The incident has been updated successfully.",
        autoDismiss: true,
      });
    },
    onError: (err) => {
      console.error(err);
      toast.error("Something went wrong!");
    },
  });

  return mutate;
}
